export const app = {
  namespaced: true,
  state: {
    unreadNotificationCount: 0,
    hasUpcomingMeetings: false,
    homeBootstrapAt: null,
  },
  mutations: {
    setHomeBootstrap(state, payload = {}) {
      if (typeof payload.unreadNotificationCount === 'number') {
        state.unreadNotificationCount = payload.unreadNotificationCount;
      }
      if (typeof payload.hasUpcomingMeetings === 'boolean') {
        state.hasUpcomingMeetings = payload.hasUpcomingMeetings;
      }
      state.homeBootstrapAt = Date.now();
    },
    setUnreadNotificationCount(state, count) {
      state.unreadNotificationCount = count;
    },
    setHasUpcomingMeetings(state, value) {
      state.hasUpcomingMeetings = value;
    },
  },
};
